import {Injectable} from "@angular/core";
import {UtilsService} from "../../utils/utils.service";
import {HttpService} from "../technique/http.service";
import {Observable, Subject} from "rxjs";
import {FermeturePonctuelleDTO} from "../../dtos/fermeture-ponctuelle/FermeturePonctuelleDTO";
import {GraphQLService} from "../technique/graphql.service";
import {catchError, map} from "rxjs/operators";
import {FermeturePonctuelleFilter} from "../../dtos/fermeture-ponctuelle/FermeturePonctuelleFilter";

@Injectable({providedIn: 'root'})
export class FermeturePoncutelleService {

  private subjectOpenDialog = new Subject<FermeturePonctuelleDTO>();
  openDialogEdition$ = this.subjectOpenDialog.asObservable();

  private subjectFermeturePonctuelleSaved = new Subject<FermeturePonctuelleSavedSupplier>();
  fermeturePonctuelleSaved = this.subjectFermeturePonctuelleSaved.asObservable();

  constructor(private utils: UtilsService,
              private httpSvc: HttpService,
              private graphQlSvc: GraphQLService
  ) {
  }

  announceOpenDialogEdition = (fermeturePonctuelle: FermeturePonctuelleDTO) => {
    this.subjectOpenDialog.next(fermeturePonctuelle);
  };

  announceFermeturePonctuelleSaved = (fermeturePonctuelle: FermeturePonctuelleDTO, isUpdate: boolean = false) => {
    this.subjectFermeturePonctuelleSaved.next({isUpdate, fermeturePonctuelle} as FermeturePonctuelleSavedSupplier);
  }

  saveFermeturePonctuelle = (fermeturePonctuelle: FermeturePonctuelleDTO) => {
    return this.httpSvc.post(`dolrest/fermeture-ponctuelle/save`, fermeturePonctuelle).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  getJourFerie = (): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
      {
        allJourFerie {
              code,
              libelle,
              date
          }
      }
    `).pipe(map(result => result.allJourFerie))
  }

  getPerimetreFermeture = (): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
      {
        allPerimetreFermeture {
              code
          }
      }
    `).pipe(map(result => result.allPerimetreFermeture))
  }

  getFermeturePonctuelle = (filter: FermeturePonctuelleFilter): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
      {
        allFermeturePonctuelle (filters: {
          ${filter.idUniteProduction != null ? `idUniteProduction: ${filter.idUniteProduction},` : ''}
          ${filter.perimetre != null ? `perimetre: "${filter.perimetre}",` : ''}
          ${filter.dateDebut != null ? `dateDebut: "${filter.dateDebut}",` : ''}
          ${filter.dateFin != null ? `dateFin: "${filter.dateFin}",` : ''}
        }) {
              id,
              idUniteProduction,
              libelle,
              code,
              dateFermeture,
              perimetreFermetureList {
                code
              }
          }
      }
    `).pipe(map(result => result.allFermeturePonctuelle))
  }

  getFermeturePonctuelleByListeBesoin = (filter: FermeturePonctuelleFilter): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
      {
        allFermeturePonctuelleByListeBesoin (filters: {
          ${filter.idUniteProduction != null ? `idUniteProduction: ${filter.idUniteProduction},` : ''}
          ${filter.perimetre != null ? `perimetre: "${filter.perimetre}",` : ''}
          ${filter.idWorkflowInstance != null ? `idWorkflowInstance: ${filter.idWorkflowInstance},` : ''}
        }) {
              id,
              idUniteProduction,
              libelle,
              code,
              dateFermeture,
              perimetreFermetureList {
                code
              }
          }
      }
    `).pipe(map(result => result.allFermeturePonctuelleByListeBesoin))
  }

  deleteFermeturePonctuelleByFilters(idsToDelete: number[]) {
    return this.httpSvc.delete(`dolrest/fermeture-ponctuelle/delete?idsToDelete=${idsToDelete}`, null).pipe(
      catchError(error => this.utils.handleError(error, true))
    );
  }

  isDateOnFermeturePonctuelle(date: Date, fermeturePonctuelleList: FermeturePonctuelleDTO[]): boolean {
    this.utils.customFormatDate(new Date(date).toDateString(), this.utils.findDateFormat(new Date(date).toDateString()), 'DD-MM')
    return fermeturePonctuelleList.filter(fp => this.utils.customFormatDate(fp.dateFermeture.toString(), this.utils.findDateFormat(fp.dateFermeture.toString()), 'DD-MM') === this.utils.customFormatDate(new Date(date).toDateString(), this.utils.findDateFormat(new Date(date).toDateString()), 'DD-MM')).length > 0;
  }

}

export interface FermeturePonctuelleSavedSupplier {
  isUpdate: boolean;
  fermeturePonctuelle: FermeturePonctuelleDTO;
}
